

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore'; // Switch to full Firestore SDK
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFFwkXu0bgTtK8tPv3k8Y1klwEOlPBens",
  authDomain: "milli-8fba8.firebaseapp.com",
  projectId: "milli-8fba8",
  // storageBucket: "milli-8fba8.appspot.com",
  storageBucket: "millihq",

  messagingSenderId: "527310788757",
  appId: "1:527310788757:web:d6cabc21e909752ddf239c",
  measurementId: "G-6RXZHMGQR0"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app); // Full Firestore SDK initialized here
const storage = getStorage(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { firestore, storage, auth };
